import { BadgeCheck } from "lucide-react";

export default function VerifiedBadge({ size = 14, className = "", showLabel = false }) {
  return (
    <span className={`inline-flex items-center gap-1 text-brand ${className}`} title="Admin-verified by EarnMate" data-testid="verified-badge">
      <BadgeCheck className={`shrink-0`} style={{ width: size, height: size }} fill="currentColor" stroke="white" strokeWidth={2.5} />
      {showLabel && <span className="text-xs font-medium">Verified</span>}
    </span>
  );
}
